var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisabledResetFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3125 9.33333H15.5833C15.2222 8.11111 14.5347 7.11111 13.5208 6.33333C12.5069 5.55556 11.3333 5.16667 10 5.16667C8.375 5.16667 6.99653 5.73264 5.86458 6.86458C4.73264 7.99653 4.16667 9.375 4.16667 11C4.16667 12 4.39236 12.9167 4.84375 13.75C5.29514 14.5833 5.90278 15.2639 6.66667 15.7917V13.5H8.33333V18.5H3.33333V16.8333H5.29167C4.43056 16.1389 3.75 15.2882 3.25 14.2812C2.75 13.2743 2.5 12.1806 2.5 11C2.5 9.95833 2.69792 8.98264 3.09375 8.07292C3.48958 7.16319 4.02431 6.37153 4.69792 5.69792C5.37153 5.02431 6.16319 4.48958 7.07292 4.09375C7.98264 3.69792 8.95833 3.5 10 3.5C11.7917 3.5 13.3646 4.05208 14.7187 5.15625C16.0729 6.26042 16.9375 7.65278 17.3125 9.33333Z",
    fill: "#b9b9b9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 21V19.3333H19.6667V21H16.3333ZM13 16.8333V15.1667H23V16.8333H13ZM10.5 12.6667V11H25.5V12.6667H10.5Z",
    fill: "#b9b9b9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledResetFilter);
export default __webpack_public_path__ + "static/media/DisabledResetFilter.fa66b4d6a15c1943e3ae73affa94cda7.svg";
export { ForwardRef as ReactComponent };